import { computed, type ComputedRef } from 'vue';
import { useWindowScroll } from '@vueuse/core';

import { getSpaId, isAuthenticated } from '@/shared/lib/auth';
import { MENU_LINKS, RIGHT_PANEL_LINKS } from '../config';
import type { NavLink } from './types';

export const useHeader = (): {
  spaId: number | undefined;
  menuLinks: NavLink[];
  visibleRightPanel: ComputedRef<NavLink[]>;
  headerClasses: ComputedRef<Record<string, boolean>>;
} => {
  const spaId = getSpaId();

  const { y: scrollPosY } = useWindowScroll();

  const headerClasses = computed<Record<string, boolean>>(() => ({
    'scrolled blur-l op-100': scrollPosY.value > 20,
  }));

  const visibleRightPanel = computed<NavLink[]>(() =>
    RIGHT_PANEL_LINKS.filter((item) => (isAuthenticated() ? item : false)).map(
      (navLinkItem): NavLink => ({
        ...navLinkItem,
        link: navLinkItem.withDogtag && spaId ? `/account/${spaId}` : navLinkItem.link,
      })
    )
  );

  return {
    spaId,
    menuLinks: MENU_LINKS,
    visibleRightPanel,
    headerClasses,
  };
};
